export class NdJson {
    static parse(data) {
        const lines = data.trim().split('\n');
        return lines.map(line => JSON.parse(line));
    }
    static stringify(data) {
        return data.map(item => JSON.stringify(item)).join('\n');
    }
}
